import { FC, useContext } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import clsx from 'clsx'

import Button from 'components/parts/button/button'
import screenSizeContext from 'context/screenSizeContext'

import { Pathname } from 'constants/data'
import { MediaNames } from 'constants/media-constanst'
import { ICrowdWebinarBanner, logoData, imgDataWide } from './data'

import styles from './crowd-webinar-banner.module.scss'

const CrowdWebinarBanner: FC<ICrowdWebinarBanner> = ({ isWide, crowdRef }) => {
  const { windowSize } = useContext(screenSizeContext)

  const isWidePC = isWide && windowSize !== MediaNames.PC_MIN

  const image = isWidePC ? imgDataWide : imgDataWide
  return (
    <div className={clsx(styles.crowdBannerWrapper, { [styles.isWide]: isWide })} ref={crowdRef}>
      <div className={clsx(styles.txtWrap)}>
        <div className={styles.title}>Поддерживаем врачей в учебе и жизни</div>
        <div className={styles.subtitle}>
          Medpoint присоединяется к фонду «ВБлагодарность» для помощи медикам, оказавшимся в трудной
          жизненной ситуации. Теперь мы ежемесячно будем переводить фонду сумму, равную количеству
          часов, проведенных каждым из вас за просмотром вебинаров.
        </div>
        <div className={styles.btnWrap}>
          <Link href={`/${Pathname.CROWD_FUNDING}`}>
            <Button>Подробнее</Button>
          </Link>
          <Image className={styles.logo} {...logoData} />
        </div>
      </div>
      <div className={clsx(styles.imgWrap)}>
        <Image {...image} />
      </div>
    </div>
  )
}

export default CrowdWebinarBanner
